module.exports = __webpack_public_path__ + "static/media/7-item-a.674dc964.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/women/7-item-a.jpg
// module id = 1206
// module chunks = 33